import React, { useMemo, memo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableProps,
  TableRow,
  Typography,
} from "@mui/material";
import { TableVirtuoso } from "react-virtuoso";

import APITaskTableRow from "../jira/APITaskTableRow";
import APITaskTableRowFull from "../jira/APITaskTableRowFull";
import { faGaugeSimpleMed } from "@fortawesome/free-solid-svg-icons";

function TableElementsInteroperability({
  elements,
  elementTypes,
  t,
  matches,
  handleElementTypeChange,
  handleElementDurationChange,
  handleElementEffortChange,
  handleElementSizeChange,
  handleElementComplexityChange,
  handleDeleteElement,
  numberOfColumns,
  needEstimated,
  idEstimationType,
  selectedAPI,
  selectedElementIdsToDelete,
  handleToggleElementToDelete,
  isElementIgnored,
}: any) {
  const [activeRowId, setActiveRowId] = useState(
    null as string | number | null,
  );

  const rowHandlers = useMemo(
    () => ({
      onElementTypeChange: handleElementTypeChange,
      onDurationChange: handleElementDurationChange,
      onEffortChange: handleElementEffortChange,
      onSizeChange: handleElementSizeChange,
      onComplexityChange: handleElementComplexityChange,
    }),
    [
      handleElementTypeChange,
      handleElementDurationChange,
      handleElementEffortChange,
      handleElementSizeChange,
      handleElementComplexityChange,
    ],
  );

 
  const elementsWithSelection = useMemo(() => {
  const selectedIds = new Set(
    selectedElementIdsToDelete.map((id: any) => String(id)),
  );

  return elements.map((elem: any) => ({
    ...elem,
    isSelectedToDelete: selectedIds.has(String(elem.apiID)),
  }));
}, [elements, selectedElementIdsToDelete]);

  const renderRow = (index: number, elem: any) => {
    const isActive = activeRowId === elem.apiID;

    const RowComponent = isActive ? APITaskTableRowFull : APITaskTableRow;
    const isIgnored = isElementIgnored?.(elem) ?? false;

    return (
      <RowComponent
        task={elem}
        t={t}
        elementTypes={elementTypes}
        matches={matches}
        onRowDataChange={rowHandlers}
        onDeleteRow={() => handleDeleteElement(elem.apiID)}
        estimated={!needEstimated}
        idEstimationType={idEstimationType}
        selectedAPI={selectedAPI}
        isActive={isActive}
        onActivate={() => setActiveRowId(elem.apiID)}
        isSelectedToDelete={elem.isSelectedToDelete}
        onToggleDeleteSelection={() => handleToggleElementToDelete(elem.apiID)}
        isIgnored={isIgnored}
      />
    );
  };

  return (
    <TableVirtuoso
      style={{ height: 600, width: "100%" }}
      data={elementsWithSelection}
      computeItemKey={(index, item: any) => item.apiID}
      components={{
        Table: (props: TableProps) => (
          <Table
            {...props}
            sx={{
              tableLayout: "fixed",
              width: "100%",
            }}
          />
        ),
        TableHead,
        TableBody,
        TableRow,
      }}
      fixedHeaderContent={() => (
        <TableRow>
          <TableCell width="4%" sx={{ backgroundColor: "#F5F5F5" }}>
            <Typography variant="subtitle2" align="center">
              Borrar
            </Typography>
          </TableCell>
          <TableCell width="31%" sx={{ backgroundColor: "#F5F5F5" }}>
            <Typography variant="subtitle2" align="center">
              {t("estimation_page.element")}
            </Typography>
          </TableCell>

          <TableCell width="15%" sx={{ backgroundColor: "#F5F5F5" }}>
            <Typography variant="subtitle2" align="center">
              {t("project_page.elem_type")}
            </Typography>
          </TableCell>

          <TableCell width="10%" sx={{ backgroundColor: "#F5F5F5" }}>
            <Typography variant="subtitle2" align="center">
              {t("estimation_page.element_size")}
            </Typography>
          </TableCell>

          <TableCell width="10%" sx={{ backgroundColor: "#F5F5F5" }}>
            <Typography variant="subtitle2" align="center">
              {t("estimation_page.element_complexity")}
            </Typography>
          </TableCell>

          <TableCell width="10%" sx={{ backgroundColor: "#F5F5F5" }}>
            <Typography variant="subtitle2" align="center">
              {t("estimation_page.total_element_effort")} (Hrs)
            </Typography>
          </TableCell>

          <TableCell width="10%" sx={{ backgroundColor: "#F5F5F5" }}>
            <Typography variant="subtitle2" align="center">
              {t("estimation_page.days_duration")}
            </Typography>
          </TableCell>

          <TableCell width="8%" sx={{ backgroundColor: "#F5F5F5" }}>
            <Typography variant="subtitle2" align="center">
              {t("reports_page.general.estatus")}
            </Typography>
          </TableCell>

          <TableCell width="2%" sx={{ backgroundColor: "#F5F5F5" }} />
        </TableRow>
      )}
      itemContent={renderRow}
      increaseViewportBy={200}
      overscan={10}
    />
  );
}

export default memo(TableElementsInteroperability);
